export enum INoteParentType {
  cruise = "cruise",
  day = "day",
  trip = "trip",
}
